"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _array = require("@widergy/web-utils/lib/array");

var _fieldsHelper = require("./fieldsHelper");

function _default(fields, fieldValues, replaceFieldNames) {
  var getFieldName = function getFieldName(field) {
    return replaceFieldNames ? "id".concat(field.id) : field.key;
  };

  var fieldById = function fieldById(id) {
    return fields.find(function (field) {
      return field.id === id;
    });
  };

  var fieldOptionById = function fieldOptionById(optionId) {
    return (0, _array.flatten)(fields.map(function (field) {
      return field.field_options;
    })).find(function (fieldOption) {
      return fieldOption && fieldOption.id === optionId;
    });
  };

  var fieldSelectedOptionId = function fieldSelectedOptionId(field) {
    return field.field_options.filter(function (fieldOption) {
      return fieldValues[getFieldName(field)] === fieldOption.name;
    }).map(function (fieldOption) {
      return fieldOption.id;
    });
  };

  var selectedOptionsIds = (0, _array.flatten)(fields.filter(_fieldsHelper.hasOptions).map(fieldSelectedOptionId));

  var isFieldVisible = function isFieldVisible(field) {
    if (field.hidden) return false;

    if ((0, _fieldsHelper.hasOptions)(field) && (0, _fieldsHelper.filterVisibleOptions)(field, selectedOptionsIds).length === 0) {
      return false;
    }

    var parentField = fieldById(field.visibility_parent_field_key_id);
    var parentToggleableField = fieldById(field.visibility_toggleable_field_id);

    if (parentField) {
      var parentFieldOptionValues = field.visibility_parent_field_option_values;

      for (var i = 0; i < parentFieldOptionValues.length; i += 1) {
        var parentFieldOption = fieldOptionById(parentFieldOptionValues[i]);

        if (parentFieldOption && fieldValues && (fieldValues[getFieldName(parentField)] === parentFieldOption.value || Array.isArray(fieldValues[getFieldName(parentField)]) && fieldValues[getFieldName(parentField)].indexOf(parentFieldOption.value) !== -1)) {
          return true;
        }
      }

      return false;
    }

    if (parentToggleableField) {
      var checkboxValue = !!fieldValues[getFieldName(parentToggleableField)];
      if (checkboxValue === field.visibility_toggleable_field_value) return true;
      return false;
    }

    return true;
  };

  return {
    isFieldVisible: isFieldVisible,
    selectedOptionsIds: selectedOptionsIds
  };
}